
import { Component, Ref, Vue } from 'vue-property-decorator'
import LoginPage from '@/components/templates/LoginPage.vue'
import LoginMethods from '@/utils/LoginMethods'

/**
 * 管理者用ログインページ
 */
@Component({
  components: {
    LoginPage,
  },
})
export default class AdminLogin extends Vue {
  /** ログインページ */
  @Ref()
  loginPage!: LoginPage

  /**
   * ログインボタン押下時の処理
   */
  private async eventClickLoginButton(): Promise<void> {
    const result = await this.submitLogin()
    if (result) {
      // ログイン成功時は塾一覧へ遷移
      this.$router.push('/admin/academies')
    } else {
      alert('ログインに失敗しました。')
    }
  }

  /**
   * ログインAPI
   *
   * @returns ログイン結果
   */
  private async submitLogin(): Promise<boolean | null> {
    return await LoginMethods.adminLogin(this.loginPage.loginId(), this.loginPage.password())
  }
}
